module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Key Figures"},"ar":{"page-title":"أرقام رئيسية"}}')
  delete Component.options._Ctor
}
